import { mainBus } from "@/common/buses";
import { useAppStore } from "@/common/store/appStore";
import { useCallback, useEffect, useRef, useState } from "react";
import { useBodyLock } from "@/common/hooks/useBodyLock";
import { useLocation } from "react-router-dom";
import { useFeedStore } from "@/common/store/useFeedStore";

export const useGlobalSearch = () => {
  const [searchValue, setSearchValue] = useState<string>("");
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);
  const isV2HeaderEnabled = useFeedStore((state) => state.isV2HeaderEnabled);
  const closeSearch = useAppStore((state) => state.closeSearch);

  const inputRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const onSetSearchValue = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  const onCloseSearch = useCallback(() => {
    inputRef.current?.blur();
    onSetSearchValue("");
    closeSearch();
  }, [inputRef, closeSearch]);

  useEffect(() => {
    mainBus.on("close_search", onCloseSearch);
    return () => mainBus.off("close_search", onCloseSearch);
  }, []);

  useEffect(() => {
    if (isSearchBarOpen && !isV2HeaderEnabled) {
      onCloseSearch();
    }
  }, [location.pathname, onCloseSearch, isV2HeaderEnabled]);

  useBodyLock(isSearchBarOpen);

  return {
    searchValue,
    isSearchBarOpen,
    inputRef,
    onSetSearchValue,
    onCloseSearch
  };
};
